import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

// Components rendered by this route should not be accessible when the user is not signed in.
function PrivateRoute({children}) {
    const {currentUser} = useAuth();
    return currentUser ? children : <Navigate to="/login"/>;
}

export default PrivateRoute;